// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesTableActionsCell-modulecell__C3AQO TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "cell" }
